export class PipelineSyncFrequencyTrackers {
  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_SYNC_FREQUENCY_PREDEFINED_CHIP_CLICK =
    '[Pipelines] pipeline settings sync frequency predefined chip click';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_SYNC_FREQUENCY_CUSTOM_CHIP_CLICK =
    '[Pipelines] pipeline settings sync frequency custom chip click';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_SYNC_FREQUENCY_TYPE_SELECTED =
    '[Pipelines] pipeline settings sync frequency type selected';
}
